/* eslint-disable react-redux/no-unused-prop-types */
/* eslint-disable react/no-unused-prop-types */
import React from 'react';
import PropTypes from 'prop-types';

// eslint-disable-next-line react/prefer-stateless-function
class InputPropTypes extends React.Component {
  render() {
    return null;
  }
}
InputPropTypes.propTypes = {
  /** `true` if the field is focused. */
  active: PropTypes.bool,
  /** Disables the input. */
  disabled: PropTypes.bool,
  /** A unique identifier for the input. */
  id: PropTypes.string.isRequired,
  /** `true` if the input is in error state and has been touched. */
  invalid: PropTypes.bool,
  /** A name for the component. */
  name: PropTypes.string.isRequired,
  /** Handler for blur event */
  onBlur: PropTypes.func,
  /** handler for change event */
  onChange: PropTypes.func,
  /** handler for focus event */
  onFocus: PropTypes.func,
  /** If the input is required. Used for validation. */
  required: PropTypes.bool
};
export { InputPropTypes };